import FirebaseConfig from "../firebaseConfig";

const db = FirebaseConfig.firestore(),
  usersRef = db.collection('admins');

export async  function getAdmin(userId,callback){
  try {
    const user = await usersRef.where('uid', '==', userId).limit(1).get();
    if(user.size){
        localStorage.setItem("docid", user.docs[0].id);
        callback(user.docs[0].data(),true);
    }else{
        callback({},false);
    }
   
  } catch (error) {
    console.log("error  " ,error);
    callback({},false);
    
  }
};

